import Keyboard, { KeyboardReactInterface } from "react-simple-keyboard";
import React, { ReactNode, useState, useRef, useEffect } from "react";
import "./AdminKeyboard.scss";
import Input from "./Input";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import SvgIcon from "@mui/material/SvgIcon";
import "./AlertModal.scss";
import axiosInstance from "../api/axiosInstance";
import { useHistory } from "react-router-dom";
import ArrowDropDownOutlinedIcon from "@mui/icons-material/ArrowDropDownOutlined";
import AlertModal from "./AlertModal";
interface AlertModalProps {
  children?: ReactNode;
  onClose: () => void;
  title?: string;
  content?: string;
  show: boolean;
  companyId?: string;
  target?: string;
  onCallback?: (data: any) => void;
}

const AdminKeyboard: React.FC<AlertModalProps> = ({
  children,
  onClose,
  onCallback,
  title,
  content,
  show,
  companyId,
  target,
}) => {
  const [modalTitle, setModalTitle] = useState<string>("관리자 조회 실패");
  const [modalContent, setModalContent] = useState<string>("");
  const [modalShow, setModalShow] = useState<boolean>(false);
  const [userLoginId, setUserLoginId] = useState<string>("");
  const [userId, setUserId] = useState<string>("");
  // const [kioskUserId, setKioskUserId] = useState<string>("");
  const [idShow, setIdShow] = useState<boolean>(false);
  const [userPassword, setUserPassword] = useState<string>("");
  const [adminList, setAdminList] = useState<any[]>([]);
  const keyboardRef = useRef<KeyboardReactInterface | null>(null);
  const history = useHistory();
  const theme = "hg-theme-default hg-theme-number";

  const numberLayout = {
    default: ["1 2 3", "4 5 6", "7 8 9", "지우기 0 재입력"],
  };
  const display = {
    "{alt}": ".?123",
    "{smileys}": "\uD83D\uDE03",
    "{shift}": "⇧",
    "{shiftactivated}": "⇧",
    "{enter}": "return",
    "{bksp}": "⌫",
    "{altright}": ".?123",
    "{downkeyboard}": "🞃",
    "{space}": " ",
    "{default}": "ABC",
    "{back}": "⇦",
  };

  const adminSelect = async () => {
    console.log('companyId', companyId)
    await axiosInstance()
      .post(`/kiosk/selectAdminUser.do`, {
        companyId: Number(companyId),
      })
      .then((res) => {
        console.log(res);
        if (res.data.status === 400) {
          setModalContent(res.data.resultMsg);
          setModalShow(true);
        } else {
          if (res.data.list.length > 0) {
            const filteredList = res.data.list.filter((item: any) => item.kioskLoginPwd); // kioskLoginPwd가 존재 하는 값들만 필터
            setAdminList(filteredList);
            if (filteredList.length > 0) {
              // 첫번째 관리자 기본 세팅
              setUserLoginId(filteredList[0].userLoginId);
              setUserId(filteredList[0].userId)
            } else {
              // ERP 내에 키오스크 로그인 비밀번호가 설정 되어야 함(kioskLoginPwd)
              setModalContent("키오스크 비밀번호가 설정 된 관리자가 없습니다.");
              setModalShow(true);
            }
          }
        }
      });
  };

  const checkAdminPwd = async () => {
    await axiosInstance()
      .post(`/kiosk/adminSameCheck.do`, {
        companyId: companyId,
        userId: userId,
        userPassword: userPassword,
        kioskLoginPwd: userPassword,
      })
      .then((res) => {
        if (res.data.status === 400) {
          setModalContent(res.data.resultMsg);
          setModalShow(true);
          return false;
        } else {
          if (target === "admin") {
            onClose();
            history.push(`/adminPay/${userId}/${companyId}`);
          } else history.push("/contract");
        }
      });
  };

  const onKeyPress = (button: string) => {
    if (button === "재입력") {
      setUserPassword("");
      keyboardRef.current?.clearInput();
    } else if (button === "지우기") {
      setUserPassword(userPassword.slice(0, -1));
    } else {
      if (userPassword.length >= 11) return false;
      setUserPassword(userPassword + button);
    }
  };

  const handleTouchMove = (e: any) => {
    // 특정 div 영역 내에서는 터치 이벤트의 기본 동작을 막지 않음
    e.stopPropagation(); // 이벤트 전파 중단
  };

  useEffect(() => {
    if (show) {
      adminSelect();
    }
    const adminWrap = document.getElementById('admin-select-item');
    if (adminWrap) {
      adminWrap.addEventListener('touchmove', handleTouchMove, { passive: false });
      return () => {
        adminWrap.removeEventListener('touchmove', handleTouchMove);
      };
    }

  }, [show]);

  return (
    <div className="modal-overlay">
      {modalShow && (
        <AlertModal
          onClose={() => {
            setModalShow(false);
          }}
          title={modalTitle}
          content={modalContent}
        ></AlertModal>
      )}
      <div className="admin-modal-container">
        <div className="modal-header">
          {/* <button className="modal-close" onClick={onClose}>
            Close
          </button> */}
        </div>
        <div className="admin-modal-content">
          <div className="admin-title">
            <span>{title ? title : "관리자 확인"}</span>
            <SvgIcon
              component={CloseOutlinedIcon}
              style={{
                fontSize: "3em",
                position: "absolute",
                left: "90%",
                color: "#71798C",
              }}
              onClick={onClose}
            ></SvgIcon>
          </div>
          <div className="admin-keyboard-input-wrap">
            <div
              className="admin-select-id"
              onClick={() => {
                setIdShow(!idShow);
              }}
            >
              <span className="id">관리자 아이디</span>
              <span className="value">
                {userLoginId}
                <SvgIcon
                  component={ArrowDropDownOutlinedIcon}
                  style={{ fontSize: "1.2em" }}
                ></SvgIcon>
              </span>
              {idShow && (
                <div className="admin-select-item" id="admin-select-item">
                  {adminList.length > 0 &&
                    adminList.map((e) => (
                      <span
                        onClick={() => {
                          setUserLoginId(e.userLoginId);
                          setUserId(e.userId);

                        }}
                        className={""}
                      >
                        {e.userLoginId}
                      </span>
                    ))}
                </div>
              )}
            </div>

            <div className="admin-password">
              <span className="id">관리자 비밀번호</span>
              <span className="value">{userPassword}</span>
            </div>
          </div>
          <Keyboard
            keyboardRef={(r) => (keyboardRef.current = r)}
            layout={numberLayout}
            display={display}
            theme={theme}
            onKeyPress={onKeyPress}
          ></Keyboard>
          <div className="admin-dec">
            <span>면허를 직접 입력하는 경우 관리자 확인이 필요합니다.</span>
          </div>
        </div>

        <div className="admin-btn-wrap">
          <div className="btn-wrap">
            <button
              style={{ fontSize: "1.8em", border: "none" }}
              onClick={() => {
                onCallback ? onCallback({ userId: userId, userPassword: userPassword }) : checkAdminPwd();
              }}
            >
              확인하고 다음 단계로
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminKeyboard;
